module.exports = __webpack_public_path__ + "img/64.80c4963b.jpg";